import logo from "./assets/generic/logo.svg";
import background from "../../assets/background_.jpg";

/**
 * Generic "Schadenportal" brand — the default, vendor-neutral skin.
 *
 * Single-accent design (rose #e11d48, per the click dummy): both the primary
 * and secondary roles use the same rose ramp, so every accent in the app
 * (buttons, active nav, focus rings, switches, checkboxes, tabs, links) renders
 * in one colour. `anchor` places the seed at the scale index each role is read
 * from — primary from [700], accent controls from [600] — so #e11d48 lands
 * exactly where it is used. See theme/utils/generateScale.js.
 */
export default {
  id: "generic",
  name: "Schadenportal",
  productName: "Schadenportal",

  // Footer: "<product> | Version x | <company>".
  footer: {
    productName: "disphere Schadenportal",
    companyName: "disphere interactive GmbH",
  },

  palette: {
    primary: { seed: "#e11d48", anchor: 700 },
    secondary: { seed: "#e11d48", anchor: 600 },
  },

  // Dark sidebar surface (the click dummy uses near-black). Skinnable per brand.
  sidebar: { background: "#111827" },

  // Contact block — drives the "Kontakt" modal (maps onto ContactDetails).
  // Neutral, vendor-agnostic defaults for the generic product.
  contact: {
    label: "Schadenportal",
    name: "",
    funktion: "Zentrale",
    telefon: "",
    fax: "",
    email: "",
  },

  // Short labels used inline in tables and the claim detail (Schadennummer prefix,
  // "<tenant> Sachbearbeiter", communication sender labels).
  labels: {
    tenantName: "Schadenportal",
    short: "Schadenportal",
  },

  // Typography is skinnable via `typography: { fontFamily, headingFamily?, bodyFamily? }`.
  // Omitted here → the default Inter face (see theme/tokens/typography.js).

  // Login / auth marketing copy shown on the left brand panel (AuthLayout).
  auth: {
    badge: "Digitale Schadenmeldung",
    headline: ["Schäden melden.", "Einfach. Sicher."],
    subtext:
      "Ihr digitales Portal zur schnellen und transparenten Abwicklung " +
      "von Versicherungsschäden – vom Eingang bis zur Auszahlung.",
  },

  assets: {
    logo,
    logoAlt: "Schadenportal Logo",
    background,
    // Favicon is optional per skin. The generic skin uses the disphere signet
    // (served from FE/public at the site root).
    favicon: "/disphere_favicon.png",
  },

  // Nav items are permission-gated already; these flags let a skin additionally
  // hide items regardless of role. `undefined`/`true` = shown, `false` = hidden.
  features: {
    showSidebarTitle: true,
    // Show the Hilfe button at the bottom of the sidebar.
    help: true,
    // Where to show the user display: "header" | "sidebar" | "both".
    userDisplay: "both",
    // Claim-report wizard flow: "broker" = single-phase broker journey (top
    // stepper); "customer" = two-phase customer→broker (grouped rail + handoff).
    claimWizardFlow: "broker",
    nav: {
      claims: true,
      customers: true,
      insurers: true,
      contracts: true,
      objects: true,
      controlling: true,
      users: true,
      mail: true,
      substitutions: true,
      reminders: true,
      bookings: true,
    },
  },
};
